import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { clickedSubscribeCTA } from '../../actions/segmentEvents';
import config from '../../config';

const CTAProvider = ({ children, segmentProperties, doClickedSubscribeCTA }) => (
  <span className="sl-cta-provider">
    {React.cloneElement(children, {
      onClickPaywall: () => doClickedSubscribeCTA(segmentProperties),
      href: config.funnelUrl,
    })}
  </span>
);

CTAProvider.propTypes = {
  children: PropTypes.node.isRequired,
  segmentProperties: PropTypes.shape({}).isRequired,
  doClickedSubscribeCTA: PropTypes.func.isRequired,
};

export default connect(null, dispatch => ({
  doClickedSubscribeCTA: properties => dispatch(clickedSubscribeCTA(properties)),
}))(CTAProvider);
